
import PageviewIcon from '@mui/icons-material/Pageview';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GridActions, ActionButton } from '../../../../components/datatable/GridActions';
export const columns = [
  {
    field: 'JournalCode',
    headerName: 'Journal Code',
    // type: 'number',
    width: 150,
    // editable: true,
  },
    {
    field: 'ItemTypeID',
    headerName: 'Item Type',
    width: 100,
    // editable: true,
  },
  {
    field: 'confirmDateTime',
    headerName: 'DateTime',
    width: 150,
    // editable: true,
  },
  {
    field: 'CustName',
    headerName: 'Cust Name',
    // type: 'number',
    width: 250,
    // editable: true,
  },
  {
    field: 'ItemName',
    headerName: 'Item Name',
    // type: 'number',
    width: 250,
    // editable: true,
  },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 200,
        cellClassName: 'actions',
        renderCell: (params) => {
            return (
                <GridActions>
                    <ActionButton to={`/docmentViewAll/${params.row.JournalID}`} title="View" tone="view">
                        <VisibilityIcon />
                    </ActionButton>
                </GridActions>
            )
        }
    }
    // {
    //   field: 'fullName',
    //   headerName: 'Full name',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   width: 160,
    //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    // },
];